<template>
  <div class="mt-20">
    <div class="box" >
        <div class="box-header" style="display:flex; flex-direction:row;align-items:center">
          <div style="flex:1">
            <h4>{{item.tosTitle}}</h4>
            <small>
            <label class="md-check">
            <input type="checkbox" v-model="item.isChecked" @change="checkHandler">
            <i class="blue"></i>{{item.tosAgreeText}}</label>
            </small>
          </div>
          <div>
            <button class="btn btn-m line-1 mr-10" @click="openItem">
              <i :class="['carat', item.isOpen ? 'icon-arrow-line-up' : 'icon-arrow-line-down']"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="box" v-show="item.isOpen">
      <div class="box-body scrollable" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick',axis:'yx'}">
      <div class="ph-20 pv-20">
      <pre v-html="item.tosContents"></pre>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  methods: {
    checkHandler(){
      this.$emit('agreeCheckEvent', this.item);
    },
    checkItem(){
      this.item.isChecked = !this.item.isChecked;
    },
    openItem(){
      debugger;
      this.$emit('agreeOpenEvent', this.item);
    }
  }
}
</script>

<style>

</style>